var _title, _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgGeneral = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "51px",
    viewBox: "0 0 52 51",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "B07AE9F8-2394-4D9B-825E-518E2EFFE1AD")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,8.5 L8.5,19.125 L19.125,19.125 L19.125,8.5 L8.5,8.5 Z M44.625,27.625 C45.7986051,27.625 46.75,28.5763949 46.75,29.75 L46.75,44.625 C46.75,45.7986051 45.7986051,46.75 44.625,46.75 L29.75,46.75 C28.5763949,46.75 27.625,45.7986051 27.625,44.625 L27.625,29.75 C27.625,28.5763949 28.5763949,27.625 29.75,27.625 L44.625,27.625 Z M21.25,27.625 C22.4236051,27.625 23.375,28.5763949 23.375,29.75 L23.375,44.625 C23.375,45.7986051 22.4236051,46.75 21.25,46.75 L6.375,46.75 C5.20139491,46.75 4.25,45.7986051 4.25,44.625 L4.25,29.75 C4.25,28.5763949 5.20139491,27.625 6.375,27.625 L21.25,27.625 Z M42.5,31.875 L31.875,31.875 L31.875,42.5 L42.5,42.5 L42.5,31.875 Z M19.125,31.875 L8.5,31.875 L8.5,42.5 L19.125,42.5 L19.125,31.875 Z M21.25,4.25 C22.4236051,4.25 23.375,5.20139491 23.375,6.375 L23.375,21.25 C23.375,22.4236051 22.4236051,23.375 21.25,23.375 L6.375,23.375 C5.20139491,23.375 4.25,22.4236051 4.25,21.25 L4.25,6.375 C4.25,5.20139491 5.20139491,4.25 6.375,4.25 L21.25,4.25 Z M44.625,4.25 C45.7986051,4.25 46.75,5.20139491 46.75,6.375 L46.75,21.25 C46.75,22.4236051 45.7986051,23.375 44.625,23.375 L29.75,23.375 C28.5763949,23.375 27.625,22.4236051 27.625,21.25 L27.625,6.375 C27.625,5.20139491 28.5763949,4.25 29.75,4.25 L44.625,4.25 Z M42.5,8.5 L31.875,8.5 L31.875,19.125 L42.5,19.125 L42.5,8.5 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset-Artboard-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Available-Filters---01-grid",
    transform: "translate(0.622005, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "COLOR/-black-COLOR/-white",
    mask: "url(#mask-2)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 51,
    height: 51
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGeneral, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/general.5014cc85.svg";
export { ForwardRef as ReactComponent };